<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
    <v-tab>
        Invoice
      </v-tab>
      <v-tab>
        Status
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn dark color="#FF3501" depressed @click="print1()" :loading="btnSave">
        <v-icon left>print</v-icon>Print Invoice
      </v-btn>
    </v-toolbar>

    <div id="printMe" v-if="orderDetails.length>0">
      <table width="100%" style="border:0px solid;" cellspacing="0" cellpadding="0">
        <tr>
          <td style="height:30px; border-bottom:1px solid;" valign="top">
            <p style="text-align:center; margin-top:0px; margin-bottom:0px;">Original for Buyers</p>
            <p
              style="text-align:center; font-size:16px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
            >Tax Invoice cum Challan</p>
            <p
              style="text-align:center; margin-top:0px; margin-bottom:0px;"
            >Rule 7 of GST Rule, 2017</p>
          </td>
        </tr>

        <tr>
          <td style="height:60px;" valign="top">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td width="50%" style="height:60px; border-right:0px solid;">
                  <img src="../../assets/Csquad_logo.png" width="120" height="100">
                </td>
                <td width="50%" style="height:60px;" valign="top">
                  <p
                    style="text-align:right; font-size:12px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                  >GSTIN: &nbsp;{{company.gstNumber}}</p>
                  <p
                    style="text-align:right; font-weight:bold; margin-bottom:0px; margin-top:4px;"
                  >{{company.shippingAddress}}</p>
                  <p
                    style="text-align:right; font-weight:bold; margin-top:4px; margin-bottom:0px;"
                  >{{company.shippingCity}} - {{company.shippingZipCode}}, {{company.stateName}}</p>
                  <p style="text-align:right; font-weight:bold; margin-bottom:0px; margin-top:4px;">
                    <i class="fa fa-phone" aria-hidden="true"></i> +91 {{company.contactNumber}}
                  </p>
                  <p
                    style="text-align:right; font-weight:bold;  margin-top:4px; margin-bottom:4px;"
                  >
                    <i class="fa fa-envelope-o" aria-hidden="true"></i> {{company.email}} |
                    <i class="fa fa-globe" aria-hidden="true"></i> www.csquad.in
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  width="33%"
                  style="border-top:1px solid; height:auto; border-right:1px solid; padding-left:10px;"
                  valign="top"
                >
                  <!-- Invoice Details 1-->
                  <table>
                    <tr>
                      <td>Reverse Charge ( If Any )</td>
                      <td>:</td>
                    </tr>
                    <tr>
                      <td>Document Through</td>
                      <td>:</td>
                    </tr>
                    <tr>
                      <td
                        style="text-align:left; font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >Bill #</td>
                      <td
                        style="text-align:left; font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >: {{customer.orderCode}}</td>
                    </tr>
                    <tr>
                      <td
                        style="text-align:left; font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >Invoice Value</td>
                      <td
                        style="text-align:left; font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >
                        :
                        <i class="fas fa-rupee-sign" style="font-size: 17px"></i>
                        {{customer.totalPrice.toFixed(2)}}
                      </td>
                    </tr>
                  </table>
                </td>
                <td
                  width="33%"
                  style="border-top:1px solid; height:auto; border-right:1px solid; padding-left:10px;"
                  valign="top"
                >
                  <!-- Invoice Details 2 -->
                  <table>
                    <tr>
                      <td>Shipping Method</td>
                      <td>:</td>
                    </tr>
                    <tr>
                      <td>Vehicle #</td>
                      <td>:</td>
                    </tr>
                    <tr>
                      <td>Date & Time Of Supply</td>
                      <td>:</td>
                    </tr>
                    <tr>
                      <td>LR #</td>
                      <td>:</td>
                    </tr>
                  </table>
                </td>

                <td
                  width="34%"
                  style="border-top:1px solid; padding-left:10px;"
                  valign="top"
                  align="right"
                >
                  <!-- Invoice Other Details -->
                  <table>
                    <tr>
                      <td
                        style="text-align:left; font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >Invoice #</td>
                      <td
                        style="text-align:left; font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >{{customer.orderCode}}</td>
                    </tr>
                    <tr>
                      <td>Invoice Date</td>
                      <td>: {{customer.date}}</td>
                    </tr>
                    <tr>
                      <td>Req. Ship Date</td>
                      <td>:</td>
                    </tr>
                    <tr>
                      <td>Due Date</td>
                      <td>:</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  width="50%"
                  style="border-top:1px solid; height:25px; border-right:1px solid; background-color:#999999; text-align:center;"
                >Details of Receiver (Billed to)</td>
                <td
                  width="50%"
                  style="border-top:1px solid; background-color:#999999; height:25px; text-align:center;"
                >Details of consignee (Shipped from)</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  width="50%"
                  style="border-top:1px solid; height:auto; border-right:1px solid; padding-left:10px;"
                  valign="top"
                >
                  <!--Billed To Details -->
                  <table>
                    <tr>
                      <td>Name</td>
                      <td>:&nbsp;{{customer.name}}&nbsp;({{customer.mobileNumber}})</td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>:&nbsp;{{customer.address}}&nbsp;-<span style="font-weight:bold;font-size:11px">{{customer.pinCode}}</span></td>
                    </tr>
                    <tr>
                      <td>State </td>
                      <td>:&nbsp;{{customer.stateName}}</td>
                    </tr>
                    <tr>
                      <td>GSTIN #</td>
                      <td>:&nbsp;{{customer.gstNumber}}</td>
                    </tr>
                    <!-- <tr>
                      <td>PAN #</td>
                      <td>:&nbsp;0</td>
                    </tr> -->
                  </table>
                </td>

                <td width="50%" style="border-top:1px solid; padding-left:10px;" valign="top">
                  <!--Shipped To Details -->
                  <table>
                    <tr>
                      <td>Name</td>
                      <td>:&nbsp;{{company.companyName}}&nbsp;({{company.contactNumber}})</td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>:&nbsp;{{company.shippingAddress}}</td>
                    </tr>
                    <tr>
                      <td>State</td>
                      <td>:&nbsp;{{company.stateName}}</td>
                    </tr>
                    <tr>
                      <td>GSTIN #</td>
                      <td>:&nbsp;{{company.gstNumber}}</td>
                    </tr>
                    <!-- <tr>
                      <td>PAN #</td>
                      <td>:&nbsp;0</td>
                    </tr> -->
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr bgcolor="#999999">
                <td
                  style="border-top:1px solid; border-right:1px solid; height:20px; text-align:center;"
                  width="3%"
                >#</td>
                <td
                  width="16%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Description of Goods</td>
                <td
                  width="10%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Actual Price</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Qty</td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >
                  TAXABLE VALUE
                  <br>(A)
                </td>
                <td
                  width="15%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:35px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        colspan="2"
                        style="border-bottom:1px solid; height:15px;"
                        width="100%"
                      >CGST (B)</td>
                    </tr>
                    <tr>
                      <td width="30%" style="border-right:1px solid; height:20px;">%</td>
                      <td width="70%">Amount</td>
                    </tr>
                  </table>
                </td>

                <td
                  width="15%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:35px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        colspan="2"
                        style="border-bottom:1px solid; height:15px;"
                        width="100%"
                      >SGST (C)</td>
                    </tr>
                    <tr>
                      <td width="30%" style="border-right:1px solid; height:20px;">%</td>
                      <td width="70%">Amount</td>
                    </tr>
                  </table>
                </td>

                <td width="15%" style="border-top:1px solid;  text-align:center; height:35px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        colspan="2"
                        style="border-bottom:1px solid; height:15px;"
                        width="100%"
                      >IGST (D)</td>
                    </tr>
                    <tr>
                      <td width="30%" style="border-right:1px solid; height:20px;">%</td>
                      <td width="70%">Amount</td>
                    </tr>
                  </table>
                </td>

                <td
                  width="12%"
                  style="border-top:1px solid; border-left:1px solid; text-align:center; height:20px;"
                >(A+B+C+D) TOTAL</td>
              </tr>
            </table>
          </td>
        </tr>
        

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr v-for="(invoice, index) in orderDetails" :key="invoice.id" >
                <td
                  style="border-top:1px solid; border-right:1px solid; height:3px; text-align:center;"
                  width="3%"
                >{{index + 1}}</td>
                <td
                  width="16%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.itemName}}</td>
                <td
                  width="10%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.actualPrice.toFixed(2)}}</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.quantity}}</td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.taxableValue.toFixed(2)}}</td>
                <td
                  width="15%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="30%"
                        style="border-right:1px solid; height:20px;"
                      >
                      <span v-if="customer.stateCode == company.shippingStateCode">{{invoice.hsnRate / 2}}</span>
                      <span v-if="customer.stateCode != company.shippingStateCode">0</span>
                      </td>
                      <td width="70%">
                        <span v-if="customer.stateCode == company.shippingStateCode">{{invoice.cgst.toFixed(2)}}</span>
                        <span v-if="customer.stateCode != company.shippingStateCode">0.00</span>
                      </td>
                    </tr>
                  </table>
                </td>

                <td
                  width="15%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="30%"
                        style="border-right:1px solid; height:20px;"
                      >
                      <span v-if="customer.stateCode == company.shippingStateCode">{{invoice.hsnRate / 2}}</span>
                      <span v-if="customer.stateCode != company.shippingStateCode">0</span>
                      </td>
                      <td width="70%">
                        <span v-if="customer.stateCode == company.shippingStateCode">{{invoice.sgst.toFixed(2)}}</span>
                        <span v-if="customer.stateCode != company.shippingStateCode">0.00</span>
                      </td>
                    </tr>
                  </table>
                </td>

                <td
                  width="15%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="30%"
                        style="border-right:1px solid; height:20px;"
                      >
                      <span v-if="customer.stateCode != company.shippingStateCode">{{invoice.hsnRate}}</span>
                      <span v-if="customer.stateCode == company.shippingStateCode">0</span>
                      </td>
                      <td width="70%">
                        <span v-if="customer.stateCode != company.shippingStateCode">{{invoice.igst.toFixed(2)}}</span>
                        <span v-if="customer.stateCode == company.shippingStateCode">0.00</span>
                      </td>
                    </tr>
                  </table>
                </td>
                <td
                  width="12%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:right; height:10px;"
                >{{ invoice.totalPrice.toFixed(2) }}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr bgcolor="#999999">
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td
                  width="43%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >Colums Total</td>

                <td width="45%" style="border-top:1px solid;  text-align:center; height:10px;">
                </td>

                <td
                  width="12%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:10px;"
                ></td>
              </tr>
            </table>
          </td>
        </tr>


        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td style="border-top:1px solid;  height:20px; text-align:center;" width="77%"></td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:0px solid; height:20px;"></td>
                      <td width="70%">Net Invoice Value</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="12%"
                  style="font-weight:bold;border-top:1px solid; border-left:1px solid;  text-align:right; height:20px;"
                >{{customer.totalPrice.toFixed(2)}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td width="100%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="50%"
                        style="border-right:1px solid; height:20px;"
                      >Net Invoice Value in Words</td>
                      <td width="50%">{{totalPrice}} only</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td
                  style="border-top:1px solid; border-right:1px solid;  height:20px; padding-left:10px;"
                  width="50%"
                >
                  <p
                    style="text-align:left:"
                  >CERTIFIED THAT THE PARTICULARS GIVEN ABOVE ARE TRUE AND CORRECT</p>
                  <p style="text-align:left:">1. Goods received in good order and condition.</p>
                  <p style="text-align:left:">2. Subject to Kolkata Juridiction only.</p>
                  <p style="text-align:left:">3. Thank you for your Order</p>
                </td>

                <td width="50%" style="border-top:1px solid;  text-align:center; height:5px;">
                  <p
                    style="font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                  >CSQUAD</p>
                  <p
                    style="font-size:16px; font-weight:bold; margin-top:40px; margin-bottom:0px;"
                  >Authorized Signatory</p>
                </td>
              </tr>
            </table>
            <tr>
              <td style="border-top:1px solid;"></td>
            </tr>
          </td>
        </tr>
      </table>
    </div>
      </v-tab-item>

      <v-tab-item>
        <div class="form-container" style="margin-top:-20px;">

          <v-layout row wrap>
            <v-flex xs12>
              <v-card flat class="container">
            <v-stepper v-model="step" alt-labels class="elevation-0" v-if="customer.cancelled==false">
          <v-stepper-header>
            <v-stepper-step style="text-align:center" step="1" :complete="step > 0">Ordered
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="customer.ordered==true">
                {{customer.date}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="step > 1" class="step1">Packed
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="customer.packed==true">
                {{customer.pckDate}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="step > 2">Shipped
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="customer.shipped==true">
                {{customer.shipDate}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="step > 3">Delivered
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="customer.delivered==true">
                {{customer.deliverDate}}
              </p>
            </v-stepper-step>
          </v-stepper-header>
            </v-stepper>
            
            <v-stepper v-model="stepc" alt-labels class="elevation-0" v-if="customer.cancelled==true">
          <v-stepper-header>
            <v-stepper-step style="text-align:center" step="1" :complete="stepc > 0">Ordered
              <p style="font-size:10px;text-align:center;color:green;" class="txt" v-if="customer.ordered==true">
                {{customer.date}}
              </p>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="error" step="2" :complete="stepc > 4" class="step1">Cancelled
              <p style="font-size:10px;text-align:center;color:red;" class="txt" v-if="customer.packed==true">
                {{customer.cancelDate}}
              </p>
            </v-stepper-step>
          </v-stepper-header>
            </v-stepper>
          </v-card>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <v-card class="container" flat>
            <b-form-checkbox disabled v-model="customer.ordered">Ordered</b-form-checkbox>
            <p style="padding-top:10px;">Your order has been placed.</p>
            <p style="margin-top:-5px;color:green;">{{customer.date}}</p>
          </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <v-card class="container" flat v-if="customer.packed==true">
            <b-form-checkbox disabled v-model="customer.packed">Packed</b-form-checkbox>
            <p style="padding-top:10px;">{{customer.packedRemarks}}</p>
            <p style="margin-top:-5px;color:green;">{{customer.pckDate}}</p>
          </v-card>
          <v-card flat class="container" v-if="customer.packed==false && customer.cancelled == false">
            <p class="hvr" @click.stop="packedDialog=true">ⓘ&nbsp;Update Packed Details</p>
          </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <v-card class="container" flat v-if="customer.shipped==true">
            <b-form-checkbox disabled v-model="customer.shipped">Shipped</b-form-checkbox>
            <p style="padding-top:10px;">{{customer.shippedRemarks}}</p>
            <p style="margin-top:-5px;color:green;">{{customer.shipDate}}</p>
          </v-card>
          <v-card flat class="container" v-if="customer.packed==true && customer.shipped==false && customer.cancelled == false">
            <p class="hvr" @click.stop="shippedDialog=true">ⓘ&nbsp;Update Shipped Details</p>
          </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <v-card class="container" flat v-if="customer.delivered==true">
            <b-form-checkbox disabled v-model="customer.delivered">Delivered</b-form-checkbox>
            <p style="padding-top:10px;">{{customer.deliveredRemarks}}</p>
            <p style="margin-top:-5px;color:green;">{{customer.deliverDate}}</p>
          </v-card>
          <v-card flat class="container" v-if="customer.shipped==true && customer.delivered==false">
            <p class="hvr" @click.stop="deliveredDialog=true">ⓘ&nbsp;Update Delivered Details</p>
          </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <v-card class="container" flat v-if="customer.cancelled==true">
            <h6 style="color:red">cancelled</h6>
            <p style="padding-top:10px;">{{customer.cancelledRemarks}}</p>
            <p style="margin-top:-5px;color:green;">{{customer.cancelDate}}</p>
          </v-card>
            </v-flex>
          </v-layout>

        </div>
      </v-tab-item>
    </v-tabs-items>
    
    <v-dialog v-model="packedDialog" width="700px" persistent>
            <v-card class="container" flat>
            <b-form-checkbox v-model="customer.packed">Packed</b-form-checkbox>

            <div v-if="customer.packed==true">
              <v-dialog
                ref="dialog"
                v-model="packedDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="customer.packedDate"
                  label="Packed date *"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="customer.packedDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="packedDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
              <v-text-field v-model="customer.packedRemarks" label="Add a Remarks" ></v-text-field>
              <v-dialog
                ref="dialog"
                v-model="expectedDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="customer.expectedDate"
                  label="Expected Delivery Date *"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="customer.expectedDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="expectedDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
              <div style="text-align:right">
                <v-btn small color="error" @click="cancel()">Cancel</v-btn>
                <v-btn small color="primary" :loading="btnSave" @click="onSubmit()">Save</v-btn>
              </div>
            </div>
          </v-card>
    </v-dialog>

    <v-dialog v-model="shippedDialog" width="700px" persistent>
            <v-card class="container" flat>
            <b-form-checkbox v-model="customer.shipped">Shipped</b-form-checkbox>

            <div v-if="customer.shipped==true">
              <v-dialog
                ref="dialog"
                v-model="shippedDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="customer.shippedDate"
                  label="Shipped date *"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="customer.shippedDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="shippedDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
              <v-text-field v-model="customer.shippedRemarks" label="Add a Remarks" ></v-text-field>
              <v-dialog
                ref="dialog"
                v-model="expectedDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="customer.expectedDate"
                  label="Expected Delivery Date *"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="customer.expectedDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="expectedDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
              <div style="text-align:right">
                <v-btn small color="error" @click="cancel()">Cancel</v-btn>
                <v-btn small color="primary" :loading="btnSave" @click="onSubmit()">Save</v-btn>
              </div>
            </div>
          </v-card>
    </v-dialog>

    <v-dialog v-model="deliveredDialog" width="700px" persistent>
            <v-card class="container" flat>
            <b-form-checkbox v-model="customer.delivered">Delivered</b-form-checkbox>

            <div v-if="customer.delivered==true">
              <v-dialog
                ref="dialog"
                v-model="deliveredDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="customer.deliveredDate"
                  label="Delivered date *"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="customer.deliveredDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="deliveredDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
              <v-text-field v-model="customer.deliveredRemarks" label="Add a Remarks" ></v-text-field>
              <div style="text-align:right">
                <v-btn small color="error" @click="cancel()">Cancel</v-btn>
                <v-btn small color="primary" :loading="btnSave" @click="onSubmit()">Save</v-btn>
              </div>
            </div>
          </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from "./../../config.json";
var writtenNumber = require("written-number");
writtenNumber.defaults.lang = "en";
export default {
  data() {
    return {
      tab: null,
      stepc: 5,
      step: 1,
      packedDialog: false,
      shippedDialog: false,
      deliveredDialog: false,
      title: "buyer copy",
      invoiceData: null,
      totalPrice: null,
      output: null,
      btnSave: false,

      packedDateModel: false,
      shippedDateModel: false,
      deliveredDateModel: false,

      expectedDateModel: false,

      company: {},
      customer: {},
      orderDetails: []
    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.axios
      .get(config.API + `Orders/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.company = res.data.company;
        this.customer = res.data;
        this.step = res.data.step;
        this.orderDetails = res.data.orderDetails;
        this.totalPrice = writtenNumber(res.data.totalPrice);
      });
    },

    cancel() {
      this.getData();
      this.packedDialog = false;
      this.shippedDialog = false;
      this.deliveredDialog = false;
    },

    onSubmit() {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Orders/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),  
              packedRemarks: this.customer.packedRemarks,
              packedDate: this.customer.packedDate,
              shippedRemarks: this.customer.shippedRemarks,
              shippedDate: this.customer.shippedDate,
              deliveredRemarks: this.customer.deliveredRemarks,
              deliveredDate: this.customer.deliveredDate,
              expectedDate: this.customer.expectedDate
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
            this.packedDialog = false;
            this.shippedDialog = false;
            this.deliveredDialog = false;
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
    },

    print() {
      this.btnSave = true;
        this.axios
          .put(
            config.API + `Orders/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),  
              status: "Process"
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.btnSave = false;
            this.$router.go(-1);
            this.$htmlToPaper("printMe");
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      
    },

    print1() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style>
#printMe {
  width: 280mm;
  height: auto;
  margin: 0 auto;
  padding: 20px;
}
td {
  font-size: 11px !important;
}

@media all {
  .page-break {
    display: none;
  }
}

@media print {
  .page-break {
    display: block;
    page-break-before: always;
  }
}

body {
  font-family: "Droid Sans", sans-serif !important;
}
</style>
